export default __webpack_public_path__ + "static/media/07-lifestyle.c4f82b7d.jpg";